/**
 * This component is supposed to render a single model with the thumbnail and the name.
 * Additionally for castings the model needs the accept, decline and commment option.
 */

import React, { } from 'react';
import { getDownloadLink } from '../utils/api';

const fetchThumbnailUrl = (model) => {
    if (model.smallThumb && model.smallThumb.file) {
        const file = model.largeThumb.file;
        return getDownloadLink(file);
    }
    return ''; // or a default image URL
};


const RenderModel = ({ model = {}, modelStyle = "", castingBar = () => { } }) => {

    return (
        model ? (
            <div className={modelStyle === "" ? "model-item": modelStyle} key={model.id}>
                <div className="image">
                    <img src={fetchThumbnailUrl(model)} alt={`${model.firstName} ${model.lastName}`} />
                </div>
                {castingBar(model)}
                <div className="info">
                    <div className="name">
                        {`${model.firstName || ''} ${model.lastName || ''}`.trim() || 'N/A'}
                    </div>
                </div>
            </div>
        ) : (<div>No model found</div>)
    );

};

export default RenderModel;
